import common from './common'
import system from './system'
import recordManage from './recordManage'
import oiltabkManage from './oiltabkManage'
import timeconfig from './timeconfig'
import invoiceManage from './invoiceManage'
import grainSpecifications from './grainSpecifications'
import grainType from './grainType'
import userBond from './userBond'
import orderManage from './orderManage'
import deliveryOrder from './deliveryOrder'
import bondRecord from './bondRecord'
import priceControl from './priceControl'
import oilTankCost from './oilTankCost'
import customerOilStorage from './customerOilStorage'
import rentManage from './rentManage'
import flowManage from './flowManage'
import cyCrkManage from './cyCrkManage'
import inspectionPoint from './inspectionPoint'
import inspectionRecord from './inspectionRecord'
import patrolProblemReport from './patrolProblemReport'
import qualityControlReport from './qualityControlReport'
import technologicalInnovation from './technologicalInnovation'
import greenEnergy from './greenEnergy'
import expenseManage from './expenseManage'
import accessory from './accessory'
import ingredients from './ingredients'
import productionProcess from './productionProcess'
import vehicleManage from './vehicleManage'
import vehicleAccess from './vehicleAccess'
import equipmentLedger from './equipmentLedger'
import firefightingClockIn from './firefightingClockIn'
import fireLedger from './fireLedger'
import specialEquipment from './specialEquipment'
import materialsManage from './materialsManage'
import tenderDocument from './tenderDocument'
import purchaseOrders from './purchaseOrders'
import purchaseDelivery from './purchaseDelivery'
import purchaseInvoice from './purchaseInvoice'
import supplier from './supplier'

export default {
  common,
  system,
  recordManage,
  oiltabkManage,
  timeconfig,
  invoiceManage,
  grainSpecifications,
  grainType,
  userBond,
  orderManage,
  deliveryOrder,
  bondRecord,
  priceControl,
  oilTankCost,
  customerOilStorage,
  rentManage,
  flowManage,
  cyCrkManage,
  inspectionPoint,
  inspectionRecord,
  patrolProblemReport,
  qualityControlReport,
  technologicalInnovation,
  greenEnergy,
  expenseManage,
  accessory,
  ingredients,
  productionProcess,
  vehicleManage,
  vehicleAccess,
  equipmentLedger,
  firefightingClockIn,
  fireLedger,
  specialEquipment,
  materialsManage,
  tenderDocument,
  purchaseOrders,
  purchaseDelivery,
  purchaseInvoice,
  supplier
}
